import { useMutation } from "@apollo/client";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonSpinner,
  IonTextarea,
  IonToolbar,
} from "@ionic/react";
import { AuthContext } from "contexts/AuthContext";
import { UPDATE_USER } from "graphql/mutations";
import { closeOutline } from "ionicons/icons";
import { useContext, useEffect, useRef, useState } from "react";
import "./InputModal.css";

const InputModal = ({ account, refetchAccount, field, onDismiss }) => {
  const inputRef = useRef();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [value, setValue] = useState(undefined);
  const [errorMessage, setErrorMessage] = useState("");
  const [disabled, setDisabled] = useState(true);
  const { loading, setLoading } = useContext(AuthContext);

  const [updateUser] = useMutation(UPDATE_USER);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        variables: {
          id: account?.id,
          user: {
            [field]: value,
          },
        },
      };

      await updateUser(payload);
      await refetchAccount();
      setLoading(false);
      onDismiss();
    } catch (e) {
      setLoading(false);
      setErrorMessage("Username is already in use.");
    }
  };

  useEffect(() => {
    if (field === "username") {
      setTitle("Choose a username");
      setDescription(
        "Your unique referral link will be generated from your username"
      );
    }
    if (field === "bio") {
      setTitle("Add a bio");
      setDescription("This will appear on your public profile");
    }
  }, [field]);

  useEffect(() => {
    if (!value) setDisabled(true);
    else setDisabled(false);
  }, [value]);

  useEffect(() => {
    let setTextAreaSelection = async () => {
      var el = await inputRef.current.getInputElement();
      var len = el.value.length;
      if (el.setSelectionRange) {
        el.setSelectionRange(len, len);
      }
    };

    let setFocus = () => {
      if (field === "bio") {
        setTimeout(() => setTextAreaSelection && setTextAreaSelection(), 300);
      }
      if (field === "username") {
        setTimeout(() => setFocus && inputRef.current.setFocus(), 300);
      }
    };

    if (
      field &&
      inputRef.current &&
      inputRef.current.getInputElement() !== document.activeElement
    )
      setFocus();

    return () => {
      setTextAreaSelection = null;
      setFocus = null;
    };
  }, [inputRef, field]);

  return (
    <IonContent fullscreen scrollY={false} className={"input-modal-root"}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="end">
            <IonButton onClick={() => onDismiss()} color="dark">
              <IonIcon icon={closeOutline} size="large" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonHeader collapse="condense" className={"input-header"}>
        <IonToolbar>
          <h1 slot="start">{title}</h1>
        </IonToolbar>
      </IonHeader>
      <IonList lines="none">
        <IonItem>
          <IonLabel className={"ion-text-wrap"}>
            <p>{description}</p>
          </IonLabel>
        </IonItem>
        <IonItem>
          {field !== "bio" && (
            <IonInput
              ref={inputRef}
              placeholder={field}
              value={typeof value !== "undefined" ? value : account?.[field]}
              onIonChange={(e) => setValue(e.target.value)}
            />
          )}
          {field === "bio" && (
            <IonTextarea
              ref={inputRef}
              rows={5}
              placeholder={field}
              value={typeof value !== "undefined" ? value : account?.[field]}
              onIonChange={(e) => setValue(e.target.value)}
            />
          )}
        </IonItem>
        {field === "username" && (
          <IonItem>
            <p>
              oshi.team/
              {typeof value !== "undefined" ? value : account?.[field]}
            </p>
          </IonItem>
        )}
        {errorMessage && (
          <IonItem className={"error-message"}>
            <IonLabel color={errorMessage ? "danger" : "success"}>
              {errorMessage}
            </IonLabel>
          </IonItem>
        )}
        <IonButton
          className={"continue-button"}
          disabled={disabled || loading}
          expand="block"
          onClick={() => onSubmit()}
        >
          {loading ? <IonSpinner name="crescent" /> : "Set"}
        </IonButton>
      </IonList>
    </IonContent>
  );
};

export default InputModal;
